<script lang="ts">
    export let direction = "right";
    export let isPaused = false;
    export let rootElement;
    let flipsvg = false;

    if (direction == "left") {
      flipsvg = true;
    }
</script>

<style lang="scss">
  * {
    svg {
    overflow: visible;
  }
  .shapes > * {
    opacity: 0;
    animation-duration: 1.5s;
    animation-iteration-count: infinite;
    animation-timing-function: steps(1);
    animation-direction: alternate;
  }
  @keyframes ppu-1 {
    0% {
      opacity: 1;
    }
    33%,
    100% {
      opacity: 0;
    }
  }
  #ppu-1 {
    animation-name: ppu-1;
  }
  @keyframes ppu-2 {
    0%,
    33% {
      opacity: 0;
    }
    33%,
    66% {
      opacity: 1;
    }
    66%,
    100% {
      opacity: 0;
    }
  }
  #ppu-2 {
    animation-name: ppu-2;
  }
  @keyframes ppu-3 {
    0%,
    66% {
      opacity: 0;
    }
    66%,
    100% {
      opacity: 1;
    }
  }
  #ppu-3 {
    animation-name: ppu-3;
  }

  .paused .shapes > * {
    filter: grayscale(100%);
      opacity: 0.8;
      animation-play-state: paused;
    }
  
  

}
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 807.7 314.3" height="100%" width="100%">>
<g class:paused={isPaused} class:flip={flipsvg}>
  <g class="shapes" bind:this={rootElement}>
    <g id="ppu-3">
      <path
        d="M509 111c-22 6-44 13-65 23-6 3-12-1-18 1l-23 4c-6 0-8-1-8-7l-2-8c-2-16-5-32-4-48a16 16 0 0 0-3-8c-6-11-8-23-7-36a121 121 0 0 0 29-6 9 9 0 0 1 2-1c25-1 46-13 68-20a46 46 0 0 1 13-2c3 0 5 0 6-3h48c3 6 9 3 14 4 14 3 24 13 38 17l3 7-6 26c-2 12-5 25-4 37-5 11-4 22-6 33-1 6 0 13-6 17-3-4-10-5-11-4-10 4-19 0-29 2-2-2-5-3-7 0-4-1-4-5-4-8a177 177 0 0 1 0-17c1-7-3-8-7-6s-8 1-11 3Z"
        fill="var(--shirt)"
      />
      <path
        fill="var(--hair)"
        d="m600 28-3-7c16-6 32-16 49-20l1-1h12c24 5 26 25 30 44l4 28c2 9-1 13-10 12l-11-4 3-9c2-8-1-11-9-8-4 1-6 0-8-3-3-4-8-6-14-5l-10-1c-4-1-7-4-8-8-1-5 4-5 6-6 6-3 10-7 6-13-3-6-8-4-13-2-8 3-16 9-25 3Z"
      />
      <path
        fill="var(--pants)"
        d="M379 32c-1 13 1 25 7 36a16 16 0 0 1 3 8c-1 16 2 32 4 48a9 9 0 0 0-6 4c-6 10-15 15-25 18-14 5-27 11-41 14a274 274 0 0 0-62 23c-4 2-7 1-9-2l-10-14c1-3 8-3 4-9-9-13-16-28-22-43a5 5 0 0 1 3-5c16-8 30-21 46-30a578 578 0 0 0 55-37c16-11 34-17 53-11Z"
      />
      <path
        fill="var(--flesh)"
        d="M222 115c6 15 13 30 22 43 4 6-3 6-4 9-9 1-16 6-25 8-14 4-28 4-42 8l-22 11-32 12c-11 3-22 4-31 11-7 5-16 9-20 17-5-1-8 5-12 5-6-2-13-3-19-6-6-5-8-11-3-18 3-3 5-6 4-10 14-2 25-11 36-18l2-3c14-5 27-11 34-25a9 9 0 0 0 7-2c12-8 27-11 38-19 20-16 42-22 67-23ZM538 139c10-2 19 2 29-2 1-1 8 0 11 4-4 38-9 75-16 112l-2 20c-1 7 0 8 7 7 4-1 10-6 8 5 0 2 4 2 5 2 9-1 17 2 25 2 9 0 12 7 18 11 3 2 0 5 0 7 0 3-3 3-5 3-4 0-9-4-11 3h-8c-11-3-22-3-33-3a50 50 0 0 1-14-1c-11-3-14-7-14-18v-50c0-7-1-11-9-11l-8-2c-11-2-17-9-17-20-1-25 2-49 4-73 0-8 2-16 1-24 3-2 7-1 10-3 5-3 9-2 8 6a177 177 0 0 0 0 17c0 3 0 7 4 8l-9 50c-1 5-2 10 0 14 2 6 7 6 12 6s2-5 2-8c0-21 3-42 2-62Z"
      />
      <path
        fill="var(--hair)"
        d="M38 205c1 4-1 7-4 10-5 7-3 13 3 18 6 3 13 4 19 6 4 0 7-6 12-5 3 2 1 4 0 5-7 8-2 17 0 25 1 2 3 2 4 2 7 1 14 4 21 7s7 11 1 14c-14 8-30 13-47 9-11-3-19-9-23-21-5-14-13-26-19-39l-5-11c-1-5 1-8 5-12 10-9 22-5 33-8Z"
      />
      <path
        fill="var(--flesh)"
        d="M600 28c9 6 17 0 25-3 5-2 10-4 13 2 4 6 0 10-6 13-2 1-7 1-6 6 1 4 4 7 8 8l10 1c6-1 11 1 14 5 2 3 4 4 8 3 8-3 11 0 9 8l-3 9c-9 3-16 9-26 9-4 0-8 5-11 8s-6 5-10 2l-2-2c-8 4-15-1-21 0-6 0-9-2-12-6-1-12 2-25 4-37l6-26Z"
      />
      <path
        fill="var(--hair)"
        d="M88 217c9-7 20-8 31-11-3 8 0 12 7 15a25 25 0 0 1 6 3c6 4 5 11-1 13a50 50 0 0 1-28 4 12 12 0 0 1-10-9l-5-15ZM110 159c-7 14-20 20-34 25-5-16-3-18 13-22 6-2 13-2 19-6 2-2 2 1 2 3Z"
      />
    </g>
    <g id="ppu-1">
      <path
        fill="var(--hair)"
        d="m6 203 4-6c1-2 3-3 5-3a12 12 0 0 0 6-2 16 16 0 0 1 13-2 71 71 0 0 0 11 3 32 32 0 0 0 5 0c4-1 4-1 5-5 0-2 2-3 4-4 8-3 16-3 25-2l13-2c2-1 3-1 3 1a6 6 0 0 1-1 1c-13 6-27 12-42 12-2 0-3 0-3 2a13 13 0 0 1-6 8c-8 5-9 15-2 21a48 48 0 0 0 15 8c3 1 5 2 6 5 4-3 7-5 12-5l1-1 9-4c5-3 11-6 17-7 2 0 0 1 0 2l-9 16-3 6c-2 3-1 4 1 6a102 102 0 0 0 11 9 9 9 0 0 1 3 5c2 6 0 10-6 11a47 47 0 0 1-7 1h-8l10 7a10 10 0 0 1 3 13 6 6 0 0 1-4 3c-14 4-28 6-42 3-12-3-23-8-30-18a27 27 0 0 1-5-15c0-8-2-15-4-22l-9-38-1-1ZM714 106l2-2a22 22 0 0 0 12-4c9-6 20-8 32-10a37 37 0 0 0 4-1c11-3 21 2 30 8 4 3 5 7 6 12l6 20c2 5 1 10 0 14a33 33 0 0 0 2 13v4c-3 5-2 9 0 14v5c-4 5-7 6-13 4a42 42 0 0 1-11-5c4-5 5-10 5-15-1-3-2-5-5-6-2-1-3-1-5 1-1 2-3 1-4 1-3-1-4-3-5-4-3-5-7-8-13-8a12 12 0 0 1-2 0 24 24 0 0 1-15-6 8 8 0 0 1-3-7c0-2 1-3 3-3a19 19 0 0 0 8-3c4-2 6-6 6-10-1-7-9-10-15-6a15 15 0 0 1-7 2 21 21 0 0 0-9 2c-2 1-3 1-5-1a18 18 0 0 1-4-9Z"
      />
      <path
        d="M523 62c1 2 2 1 3 0 5-3 10-3 16 0a14 14 0 0 0 6 1h28c12 1 24 1 35 4 14 4 28 7 41 13 9 3 17 7 25 13a11 11 0 0 1 2 3c2 4 6 4 9 4l14 3a7 7 0 0 1 3 2c1 2 2 2 4 1l1 1v17c0 6-2 12-4 17-2 8-7 14-8 22a67 67 0 0 1-2 7c-2 4-1 8-2 13a21 21 0 0 0 0 3c-1 4-3 6-5 7-4 1-6 4-7 7l-10 32a60 60 0 0 0-2 8c0 2-1 2-3 2a12 12 0 0 0-2 0l-7-1c-2-1-5-1-6-4s-3-3-4-2c-3 2-5 3-7 2l-5-2-18-6-8-2a4 4 0 0 0-4-1c-2 1-2 0-3-2a24 24 0 0 1 1-6 182 182 0 0 1 4-22c0-2-1-2-2-2-12 1-23 0-34-2-9-2-17-1-25-1l-34 5-30 5c-11 1-21 3-32 3h-1c-6 1-6 1-5-5l1-11 2-16 4-34 6-27c2-11 1-21-1-31l-2-15a2 2 0 0 1 1-1c8 0 17-1 24 2 3 1 5 3 8 2a21 21 0 0 0 3-1l15-2a4 4 0 0 0 3-1c5-5 8-5 14-2Z"
        fill="var(--shirt)"
      />
      <path
        fill="var(--flesh)"
        d="M106 221c-6 1-12 4-17 7l-9 4-1 1c-5 0-8 2-12 5-1-3-3-4-6-5a48 48 0 0 1-15-8c-7-6-6-16 2-21a13 13 0 0 0 6-8c0-2 1-2 3-2 15 0 29-6 42-12a6 6 0 0 0 1-1l10-4c12-4 24-10 35-15a88 88 0 0 1 29-7l58-2 9-2 39-14 39-14a5 5 0 0 1 2 0c-1 5 0 9 3 13l4 5a47 47 0 0 1 7 14c5 13 8 28 14 41-2 2-5 1-8 2l-14 3-27 3-26 3a82 82 0 0 1-16-1 44 44 0 0 0-11 0 45 45 0 0 1-15 0 58 58 0 0 0-29 0 253 253 0 0 1-43 9l-29 1a71 71 0 0 0-25 5Z"
      />
      <path
        d="M349 196c-6-13-10-28-14-41a47 47 0 0 0-7-14l-4-5c-3-4-4-8-3-13l6-4c1 0 2-1 1-3l1-1c18-7 35-17 52-26l30-17c8-5 17-7 26-8a130 130 0 0 1 18 1l2 15c2 10 3 20 1 31l-6 27-4 34-2 16c-19 10-39 15-60 18l-27 2c-1 1-2 0-2-2l1-8-2-1-7-1Z"
        fill="var(--pants)"
      />
      <path
        fill="var(--flesh)"
        d="M610 227c3-1 6 1 8 2l18 6 5 2c2 1 4 0 7-2 2-1 3-1 4 2s4 3 6 4l7 1-2 8c0 1 0 2 2 3l25 3 13 4c5 1 10 1 13-4l7-8a11 11 0 0 1 8-4 49 49 0 0 1 13 0 4 4 0 0 1 3 3 9 9 0 0 0 9 5c2 0 3 0 2 2 0 2-2 4-4 4-2 1-2 2-1 3a7 7 0 0 1 2 8 3 3 0 0 0 1 2c2 3 2 4 0 7a8 8 0 0 0-2 6 4 4 0 0 1-3 4 2 2 0 0 0-2 3l-2 3a18 18 0 0 1-8 2c-8 0-16 0-24-2a12 12 0 0 0-6 0l-27 10a230 230 0 0 1-33 8c-11 2-21 3-32 2-7-6-11-13-11-22v-27c0-13 1-26 4-38ZM695 183c0-5-1-9 1-13a67 67 0 0 0 2-8c1-7 6-13 8-21 2-5 5-11 4-17v-18h4a18 18 0 0 0 4 9c2 2 3 2 5 1a21 21 0 0 1 9-2 15 15 0 0 0 7-2c6-4 14-1 15 6 0 4-2 8-6 10a19 19 0 0 1-8 3c-2 0-3 1-3 3a8 8 0 0 0 3 7 24 24 0 0 0 15 6 12 12 0 0 0 2 0c6 0 10 2 13 8 1 1 2 3 5 4 1 0 3 1 4-1s3-2 5-1c3 1 4 3 5 5 0 6-1 11-5 16l-15 5c-5 2-9 2-14 1-3 0-5 1-7 3l-8 6a11 11 0 0 1-3 2c-4 1-7 0-8-4 0-2-1-2-2-1l-4 1c-2 1-4 2-6 0a1 1 0 0 0-1 0c-3 1-4 0-5-2-2-2-4-3-7-2-5 1-8 0-9-4Z"
      />
    </g>
    <g id="ppu-2">
      <path
        d="M436 43a42 42 0 0 1 20-1 19 19 0 0 0 15-4c7-5 16-4 24-5 14-4 29-5 43-10 16-6 31-14 48-16 2 0 4-2 5-3h44c1 4 5 5 8 6 16 7 26 19 36 33 2 3 0 7 5 9 0 8 2 18-1 25-7 15-3 31-10 45-11 1-16 5-16 15 0 15-11 21-19 31h-7c-4-3-14-4-9-11 6-7 7-16 12-24 2-4 1-7-4-7-8 0-16 3-23 3-15 1-19 10-22 22-1 2-1 7-6 8a34 34 0 0 1-15-1c-12-2-23 2-34 6-3 1-7 4-10 3-16-6-28 3-41 9-5 3-11 8-16 5-6-3-2-11-2-17-1-2 1-4-1-6 3-1 10 2 9-4l-5-35c-1-8-4-15-4-22a31 31 0 0 0-5-18c-7-11-19-21-19-36Z"
        fill="var(--shirt)"
      />
      <path
        fill="var(--hair)"
        d="M691 51c17-3 34-10 52-11s30 8 33 26c1 4 0 8 4 11v32c-5 2-3 5-3 9 1 3 2 7-2 10s-8 1-12-1l-7-4c2-4 5-8 5-12s-1-8-5-7c-7 2-10-2-14-7-2-3-6-4-9-4l-10-3c-4-2-8-4-8-10s6-2 9-4l2-1c5-2 6-7 5-12-2-5-6-6-11-4s-11 2-16 3c-8 1-12-3-13-11Z"
      />
      <path
        fill="var(--pants)"
        d="M436 43c0 15 12 25 19 36a31 31 0 0 1 5 18c0 7 3 14 3 22l6 35c1 6-6 3-9 4-7 1-14 4-19 9a12 12 0 0 1-8 4c-19 1-35 11-52 15-9 3-15 9-20 17-2 4-4 5-8 3l-30-17c7-7 6-6 2-18-6-17-15-32-20-49 1-9 6-13 14-17 23-12 45-26 67-41a140 140 0 0 1 50-21Z"
      />
      <path
        fill="var(--flesh)"
        d="M579 159c5-1 5-6 6-8 3-12 7-21 22-22 7 0 15-3 23-3 5 0 6 3 4 7-5 8-6 17-12 24s5 8 9 11h7c0 8-3 15-6 23-9 20-5 21 12 31 14 8 30 8 46 11 6 1 11-3 16-6 11-4 22 0 26 11 3 9-3 23-13 24-8 1-17 0-24-4-11-5-22-4-33-5-17-2-33-2-49-7-5-2-8 0-9 5l-2 19c0 6 1 8 7 6 5-1 10-6 11 4 0 3 4 2 7 2l23 1c9 0 14 4 20 10 3 2 2 6 1 9s-4 3-6 3c-4-1-8-3-11 3l-6 2c-14-4-27-2-41-2-5 1-10 1-14-1-10-3-14-7-14-17v-78c0-18-3-36 0-53Z"
      />
      <path
        fill="var(--hair)"
        d="M43 201a20 20 0 0 1-6 10c-8 8-7 16 2 21 7 5 15 11 25 5h7c-6 9-9 18-8 28 0 4 1 5 5 7l19 11c4 2 5 6 4 10s-3 5-6 6c-17 5-35 7-52-1-10-5-16-13-18-25-3-16-9-32-14-48-5-18 4-28 23-26Z"
      />
      <path
        fill="var(--flesh)"
        d="M691 51c1 8 5 12 13 11 5-1 11-1 16-3s9-1 11 4c1 5 0 10-5 12l-3 1c-2 2-7-1-8 4s4 8 8 10c3 2 6 4 10 3s7 1 9 4c4 5 7 9 14 7 4-1 5 3 5 7s-3 8-5 12c-10 1-18 6-29 4-2-1-5 2-7 4-5 3-9 5-16 1-6-3-14-4-22-5a24 24 0 0 1-9-5c7-14 3-30 10-45 3-7 1-17 1-25Z"
      />
      <path
        fill="var(--hair)"
        d="M127 217c-4 8-2 13 5 17a26 26 0 0 1 7 5c4 6 2 12-4 13-10 3-21 3-31-1-11-5-9-16-11-24a11 11 0 0 1-1-3 6 6 0 0 1 5-3c10-2 20-4 30-4ZM127 167l-3 5a93 93 0 0 1-38 15c-2-18-1-19 17-22 7-1 14 1 21-2 4-1 3 2 3 4Z"
      />
      <path fill="var(--flesh)" d="M282 139v-2a2 2 0 0 0 0 1v1Z" />
      <path
        fill="var(--flesh)"
        d="M91 224h1a6 6 0 0 1 5-3c10-2 20-4 30-4 3 0 7 0 9-2 8 1 15-2 22-3 19-6 37-10 57-9 12 1 25 1 38-3 8-2 16-7 24-6 12 2 23-2 35-4 4-1 7-3 11-1 7-7 6-6 2-18-6-17-15-32-20-49-8 0-16 4-22 8a58 58 0 0 1-44 10c-14-2-27-3-39 3-19 9-41 13-60 21a27 27 0 0 1-13 3l-3 5a93 93 0 0 1-38 15c-13 9-28 12-43 14a20 20 0 0 1-6 10c-8 8-7 16 2 21 8 5 15 11 25 5h7c2-7 9-7 13-10l1-1 6-2"
      />
      <path fill="var(--flesh)" d="m84 227 1-1v1Z" />
    </g>
  </g>
  </g>
    {#if isPaused}
    <svg viewBox="-6 -5 36 36" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M10 24h-6v-24h6v24zm10 0h-6v-24h6v24zm-11-23h-4v22h4v-22zm10 0h-4v22h4v-22z"/></svg>
    {/if} 
  </svg>